var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1Soyutma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "air-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155.6 106.5",
    style: {
      enableBackground: "new 0 0 155.6 106.5"
    },
    xmlSpace: "preserve",
    width: 155.60000610351562,
    height: 106.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:3.7;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:3.4;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:3.4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000000;stroke-width:3.3;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0 svg-elem-1",
    x1: 19.8,
    y1: 15,
    x2: 52.9,
    y2: 14.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0 svg-elem-2",
    x1: 17.8,
    y1: 35.4,
    x2: 137.1,
    y2: 35.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0 svg-elem-3",
    d: "M108.1,51.1H20.6c-1.3,0-2.4-1.1-2.4-2.4v-4.6c0-1.3,1.1-2.4,2.4-2.4h94.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1 svg-elem-4",
    cx: 135.7,
    cy: 14.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2 svg-elem-5",
    d: "M39.9,58.3H24.3c-9.5,0-17.1-7.7-17.1-17.1V13.4c0-4.3,3.5-7.7,7.7-7.7h124.7c4.3,0,7.7,3.5,7.7,7.7v26.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2 svg-elem-6",
    d: "M48.6,56.2c0,0-5.5,8,0,19.8s2.7,18.8-1,25.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2 svg-elem-7",
    d: "M67.3,56.2c0,0-5.5,8,0,19.8s2.7,18.8-1,25.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2 svg-elem-8",
    d: "M86.1,56.2c0,0-5.5,8,0,19.8s2.7,18.8-1,25.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2 svg-elem-9",
    d: "M104.9,56.2c0,0-5.5,8,0,19.8s2.7,18.8-1,25.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-10",
    x1: 148.9,
    y1: 50.5,
    x2: 115.1,
    y2: 70
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-11",
    x1: 144.9,
    y1: 47.6,
    x2: 142.7,
    y2: 53.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-12",
    x1: 149,
    y1: 55.1,
    x2: 142.7,
    y2: 53.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-13",
    x1: 119.2,
    y1: 72.5,
    x2: 121.5,
    y2: 66.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-14",
    x1: 115.1,
    y1: 65,
    x2: 121.5,
    y2: 66.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-15",
    x1: 149,
    y1: 69.8,
    x2: 115.2,
    y2: 50.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-16",
    x1: 149.5,
    y1: 64.9,
    x2: 142.9,
    y2: 66.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-17",
    x1: 145.1,
    y1: 72.2,
    x2: 142.9,
    y2: 66.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-18",
    x1: 115,
    y1: 55.2,
    x2: 121.6,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-19",
    x1: 119.5,
    y1: 47.9,
    x2: 121.6,
    y2: 54
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-20",
    x1: 132,
    y1: 40.7,
    x2: 132.4,
    y2: 79.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-21",
    x1: 127.6,
    y1: 42.8,
    x2: 132,
    y2: 47.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-22",
    x1: 136.1,
    y1: 42.9,
    x2: 132,
    y2: 47.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-23",
    x1: 136.6,
    y1: 77.4,
    x2: 132.2,
    y2: 72.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3 svg-elem-24",
    x1: 128.1,
    y1: 77.3,
    x2: 132.2,
    y2: 72.3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Soyutma);
export default __webpack_public_path__ + "static/media/1.soyutma.7a4fe287829ca0a79b5769ecae0224cd.svg";
export { ForwardRef as ReactComponent };